// import CreateWorkPage from './main.vue'
// import { useDefaultModal } from '~/hooks/useModal/modals/defaultModal'

export const useCreateWork = () => {
  // 新建作品选择页面改为编辑器处理
  const resource = injectResourceLocation()
  const route = useRoute()
  trackEvent(TRACK_EVENT.启动编辑器, {
    source: resource?.source || SOURCE.HEADER,
    page: route.name,
  })

  window.location.href = '/editor/get-started'
  // const onCancel = () => {
  //   model.destroy()
  // }
  // const model = useDefaultModal({
  //   width: 546,
  //   center: true,
  //   content: <CreateWorkPage cancel={onCancel} />,
  //   footer: false,
  //   header: false,
  //   maskClosable: true,
  // })
}
